import { Suspense } from 'react'
import { DataTableLoadingSkeleton } from '~/shared/ui'
import { useResetPaginationOnMount } from '../model'
import { ActionsBar, ActionsBarLoadingSkeleton } from './actions-bar'
import { ConsignmentsTable } from './consignments-table'
import { Filters } from './filters'
import { PaginationBar } from './pagination-bar'

export function ConsignmentsPage() {
  useResetPaginationOnMount()

  return (
    <div className="flex flex-1 flex-col overflow-hidden">
      <Suspense fallback={<ActionsBarLoadingSkeleton />}>
        <ActionsBar />
      </Suspense>
      <div className="flex-1 overflow-hidden">
        <Suspense
          fallback={
            <DataTableLoadingSkeleton
              columnsCount={5}
              rowsCount={5}
              containerClassName="[&_>_div]:flex [&_>_div]:h-full [&_>_div]:flex-col [&_>_div]:justify-between"
              withStickyHeader
            />
          }
        >
          <ConsignmentsTable />
        </Suspense>
      </div>
      <PaginationBar />
      <Filters />
    </div>
  )
}
